import {
  DashboardIcon,
  HelpIcon,
  NotificationsIcon,
  ProfileIcon,
} from 'secondstep-components'

export const ADMIN_DASHBOARD_LINK = '/admin'
export const LOGO_LINK = `/dashboard`
export const PROFILE = 'PROFILE'

export const NAVIGATION_ITEMS = [
  {
    label: 'PROFILE',
    link: PROFILE,
    ariaLabel: 'User Account',
    title: 'My Account',
  },
]

export const iconMap = {
  DASHBOARD: DashboardIcon,
  HELP: HelpIcon,
  NOTIFICATIONS: NotificationsIcon,
  PROFILE: ProfileIcon,
}
